import React from 'react'

function HelpCard(props) {
    const { id, name, shortcutKey, state } = props.fields
    const handleClick = () => {

        if (typeof state === 'function') {
            state(true);
        } 
        else if (state === null) {
            state();
        }
    }
    return (
        <div className='help_button_card' key={id} >
            <button
                className={`button_padding`}
                onClick={handleClick}
                style={{ background: 'white', paddingTop: 3, paddingBottom: 3, marginBottom: 2 }}
            >
                <p className='card-header'>
                    <span>{shortcutKey}</span>: {name}
                </p>
            </button>
        </div>
    )
}

export default HelpCard
